import React, { useEffect } from 'react';
import { Route as RouterRoute, Switch, useLocation } from 'react-router-dom';

import { AposentadosDemitidosProvider } from './contexts/AposentadosDemitidos/context';
import { DependentesProvider } from './contexts/InclusaoDependente/context';
import { TitularProvider } from './contexts/InclusaoTitular/context';
import { MovimentacoesPorArquivoProvider } from './contexts/MovimentacoesPorArquivo/context';

import Home from './pages/Home';
import NotFound from './pages/NotFound';

import AguardarAnaliseAdicionar from './pages/MovimentacaoCadastral/AdicionarBeneficiario/AguardarAnalise';
import AdicionarDependente from './pages/MovimentacaoCadastral/AdicionarBeneficiario/Dependente';
import UploadDocuments from './pages/MovimentacaoCadastral/AdicionarBeneficiario/Documentos';
import EscolherTipo from './pages/MovimentacaoCadastral/AdicionarBeneficiario/EscolherTipo';
import RevisarDadosAdicionar from './pages/MovimentacaoCadastral/AdicionarBeneficiario/RevisarDados';
import SelecionarTitular from './pages/MovimentacaoCadastral/AdicionarBeneficiario/SelecionarTitular';
import AdicionarTitular from './pages/MovimentacaoCadastral/AdicionarBeneficiario/Titular';

import AguardarAnaliseAlterar from './pages/MovimentacaoCadastral/AlterarBeneficiario/AguardarAnalise';
import AlterarDependente from './pages/MovimentacaoCadastral/AlterarBeneficiario/Dependente';
import SelecionarAlterarBeneficiario from './pages/MovimentacaoCadastral/AlterarBeneficiario/SelecionarBeneficiarios';
import AlterarTitular from './pages/MovimentacaoCadastral/AlterarBeneficiario/Titular';

import DesligarBeneficiario from './pages/MovimentacaoCadastral/DesligarBeneficiario/Beneficiario';
import AguardarAnaliseDesligar from './pages/MovimentacaoCadastral/DesligarBeneficiario/ConfirmarDados';
import SelecionarDesligarBeneficiario from './pages/MovimentacaoCadastral/DesligarBeneficiario/SelecionarBeneficiarios';

import AguardarAnaliseReativar from './pages/MovimentacaoCadastral/ReativarBeneficiario/AguardarAnalise';
import ReativarBeneficiario from './pages/MovimentacaoCadastral/ReativarBeneficiario/Beneficiario';
import SelecionarReativarBeneficiario from './pages/MovimentacaoCadastral/ReativarBeneficiario/SelecionarBeneficiarios';

import AguardarTransferirBeneficiario from './pages/MovimentacaoCadastral/TransferirBeneficiario/AguardarAnalise';
import TransferirBeneficiario from './pages/MovimentacaoCadastral/TransferirBeneficiario/Beneficiario';
import SelecionarTransferirBeneficiario from './pages/MovimentacaoCadastral/TransferirBeneficiario/SelecionarBeneficiarios';

import AguardarTrocarPlano from './pages/MovimentacaoCadastral/TrocarPlano/AguardarAnalise';
import TrocarPlano from './pages/MovimentacaoCadastral/TrocarPlano/Formulario';
import SelecionarTrocarPlano from './pages/MovimentacaoCadastral/TrocarPlano/SelecionarBeneficiarios';

import ConsultarFaturas from './pages/Faturamento/ConsultarFaturas';

import FormCentroDeCusto from './pages/MovimentacaoCadastral/CentroDeCusto/Formulario';
import SelecionarCentroDeCusto from './pages/MovimentacaoCadastral/CentroDeCusto/SelecionarCentroDeCusto';

import FormLotacao from './pages/MovimentacaoCadastral/Lotacoes/Formulario';
import SelecionarLotacao from './pages/MovimentacaoCadastral/Lotacoes/Selecionar';

import HistoricoDeMovimentacao from './pages/MovimentacaoCadastral/HistoricoDeMovimentacao';
import MovimentacoesPendentes from './pages/MovimentacaoCadastral/MovimentacoesPendentes';
import MovimentacoesPorArquivo from './pages/MovimentacaoCadastral/MovimentacoesPorArquivo';

import AguardarAnaliseAposentadosDemitidos from './pages/MovimentacaoCadastral/AposentadosDemitidos/AguardarAnalise';
import CarregarDocumentosAposentadosDemitidos from './pages/MovimentacaoCadastral/AposentadosDemitidos/CarregarDocumentos';
import PreencherDadosAposentadosDemitidos from './pages/MovimentacaoCadastral/AposentadosDemitidos/PreencherDados';
import SalvarRascunhoAposentadosDemitidos from './pages/MovimentacaoCadastral/AposentadosDemitidos/SalvarRascunho';
import SelecionarAposentadosDemitidos from './pages/MovimentacaoCadastral/AposentadosDemitidos/SelecionarBeneficiarios';

import GerenciarUsuarios from './pages/InformacoesEmpresa/GerenciarUsuarios';
import InfoEmpresa from './pages/InformacoesEmpresa/InformacoesCadastro';
import EditarEndereco from './pages/InformacoesEmpresa/InformacoesCadastro/EditarEndereco';
import PesquisaCongeneres from './pages/InformacoesEmpresa/PesquisaCongeneres';

import SelecionarCartaPermanencia from './pages/DadosBeneficiario/CartaPermanencia/Selecionar';
import PesquisarBeneficiarioCarteirinhaDigital from './pages/DadosBeneficiario/Carteirinha/CarteirinhaDigital';
import SelecionarCard from './pages/DadosBeneficiario/Carteirinha/EscolherTipo';
import PesquisarBeneficiario from './pages/DadosBeneficiario/Carteirinha/PesquisarBeneficiario';
import SegundaVia from './pages/DadosBeneficiario/Carteirinha/SegundaVia';
import SolicitacaoComSucesso from './pages/DadosBeneficiario/Carteirinha/Sucesso';
import DemonstrativoCoparticipacao from './pages/DadosBeneficiario/Coparticipacao/DemonstrativoCoparticipacao';
import SelecionarBeneficiarioCoparticipacao from './pages/DadosBeneficiario/Coparticipacao/SelecionarBeneficiario';
import DadosBeneficiario from './pages/DadosBeneficiario/Dados';
import DemonstrativoImpostoRenda from './pages/DadosBeneficiario/ImpostoRenda/DemonstrativoImpostoRenda';
import SelecionarBeneficiarioImpostoRenda from './pages/DadosBeneficiario/ImpostoRenda/SelecionarBeneficiario';
import Relatorio from './pages/DadosBeneficiario/Relatorio';
import SelecionarDadosBeneficiario from './pages/DadosBeneficiario/Selecionar';
import SelecionarBeneficiarioFranquia from './pages/DadosBeneficiario/TabelaFranquia/SelecionarBeneficiario';
import TabelaFranquia from './pages/DadosBeneficiario/TabelaFranquia/VizualizaTabelaFranquia';

import AposentadosDemitidos from './pages/DadosContrato/AposentadosDemitidos';
import CartaReajuste from './pages/DadosContrato/CartaReajuste';
import ConsultarPlanosValores from './pages/DadosContrato/ConsultarPlanosValores';
import EscolherTipoContrato from './pages/DadosContrato/EscolherTipo';

import MateriaisApoio from './pages/CentralAjuda/MateriaisApoio';

import FrontEnd from './pages/TesteFrontEnd';

import { useGlobal } from './contexts/Global/context';

import PesquisaRedeSelecionaBeneficiario from './pages/RegistroAcidentados/PesquisaRede/SelecionarBeneficiarioEventual';
import PesquisaRedeSelecionaRedeAssistencial from './pages/RegistroAcidentados/PesquisaRede/SelecionarRedeAssistencial';

import ConsultaBeneficiarioEventual from './pages/RegistroAcidentados/Consulta';
import ConsultaBeneficiarioEventualAgendamento from './pages/RegistroAcidentados/Consulta/AgendamentoConsulta/SelecionarBeneficiariosEventual';
import ConsultaBeneficiarioEventualCancelamento from './pages/RegistroAcidentados/Consulta/CancelamentoConsulta';
import ConsultaBeneficiarioEventualAgendamentoDados from './pages/RegistroAcidentados/Consulta/AgendamentoConsulta/DadosCadastro';
import ConsultaBeneficiarioEventualListaConsultaDados from './pages/RegistroAcidentados/Consulta/CancelamentoConsulta/ListaConsultas';
import ConsultaBeneficiarioEventualAgendamentoDadosConsulta from './pages/RegistroAcidentados/Consulta/AgendamentoConsulta/DadosConsulta';
import ConsultaBeneficiarioEventualAgendamentoDadosMedicoConsulta from './pages/RegistroAcidentados/Consulta/AgendamentoConsulta/DadosMedicoConsulta';
import ConsultaBeneficiarioEventualAgendamentoDadosConfirmar from './pages/RegistroAcidentados/Consulta/AgendamentoConsulta/DadosConfirmar';

import SelecionarHistoricoConsultas from './pages/RegistroAcidentados/Historico';
import DadosHistoricoConsultas from './pages/RegistroAcidentados/Historico/DadosHistorico';

import { BeneficiarioEventualProvider } from './contexts/BeneficiarioEventual/context';
import { SolicitacaoGuiasProvider } from './contexts/SolicitacaoGuias/context';
import Guias from './pages/RegistroAcidentados/Guias';
import ConsultarGuias from './pages/RegistroAcidentados/Guias/ConsultarGuias/ConsultarGuias';
import GuiaSelecionarBeneficiario from './pages/RegistroAcidentados/Guias/ConsultarGuias/GuiaSelecionarBeneficiario/GuiaSelecionarBeneficiario';
import AguardarAnalise from './pages/RegistroAcidentados/SolicitacaoGuias/AguardarAnalise';
import Documentos from './pages/RegistroAcidentados/SolicitacaoGuias/CarregarDocumentos';
import PreencherDados from './pages/RegistroAcidentados/SolicitacaoGuias/PreencherDados';
import SelecionarSolicitacaoGuias from './pages/RegistroAcidentados/SolicitacaoGuias/SelecionarBeneficiarios';
import { checkAllowedRoute, isLogged } from './utils';
// import ListaSolicitacoes from './pages/DadosBeneficiario/Carteirinha/ListaSolicitacoes';

function Routes() {
    const location = useLocation();

    const dataGlobal = useGlobal();

    useEffect(isLogged, [location.pathname]);

    function Route({ path, ...rest }) {
        const checkAllowedParameter = {
            path,
            dataGlobal,
        };

        return checkAllowedRoute(checkAllowedParameter) ? <RouterRoute path={path} {...rest} /> : <NotFound />;
    }

    return (
        <>
            <TitularProvider>
                <DependentesProvider>
                    <AposentadosDemitidosProvider>
                        <MovimentacoesPorArquivoProvider>
                            <SolicitacaoGuiasProvider>
                                <BeneficiarioEventualProvider>
                                    <Switch>
                                        {/* Teste de frontend */}
                                        <Route exact path="/frontend" component={FrontEnd} />
                                        {/* Fim Teste de frontend */}

                                        <Route exact path="/:id" component={Home} />
                                        <Route exact path="/" component={Home} />

                                        {/* Informacoes da Empresa */}
                                        <Route exact path="/dados_empresa/informacoes" component={InfoEmpresa} />
                                        <Route exact path="/dados_empresa/editar_endereco" component={EditarEndereco} />
                                        <Route
                                            exact
                                            path="/dados_empresa/gerenciar_usuarios"
                                            component={GerenciarUsuarios}
                                        />
                                        <Route
                                            exact
                                            path="/dados_empresa/pesquisa_congeneres"
                                            component={PesquisaCongeneres}
                                        />
                                        {/* Informacoes da Empresa */}

                                        {/* Inicio Dados do Contrato */}
                                        <Route exact path="/dados_contrato/carta_reajuste" component={CartaReajuste} />
                                        <Route
                                            exact
                                            path="/dados_contrato/planos_valores"
                                            component={EscolherTipoContrato}
                                        />
                                        <Route
                                            exact
                                            path="/dados_contrato/planos_valores/planos_valores_aposentados_demitidos"
                                            component={AposentadosDemitidos}
                                        />
                                        <Route
                                            exact
                                            path="/dados_contrato/planos_valores/planos_valores_ativos"
                                            component={ConsultarPlanosValores}
                                        />

                                        {/* Fim Dados do Contrato */}

                                        {/* Informacoes da Empresa */}
                                        <Route
                                            exact
                                            path="/dados_beneficiario/selecionar_beneficiario_dados"
                                            component={SelecionarDadosBeneficiario}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/beneficiario_dados"
                                            component={DadosBeneficiario}
                                        />

                                        <Route
                                            exact
                                            path="/dados_beneficiario/relatorio_beneficiarios"
                                            component={Relatorio}
                                        />

                                        <Route
                                            exact
                                            path="/dados_beneficiario/carta_de_permanencia"
                                            component={SelecionarCartaPermanencia}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/carterinha_digital"
                                            component={PesquisarBeneficiarioCarteirinhaDigital}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/selecionar_acao"
                                            component={SelecionarCard}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/pesquisar_beneficiario"
                                            component={PesquisarBeneficiario}
                                        />
                                        <Route exact path="/dados_beneficiario/segunda_via" component={SegundaVia} />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/sucesso_solicitacao"
                                            component={SolicitacaoComSucesso}
                                        />

                                        {/* <Route exact path="/dados_beneficiario/lista_solicitacoes" component={ListaSolicitacoes} /> */}

                                        {/* Informacoes da Empresa */}

                                        {/* Adicionar beneficiário */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/adicionar_beneficiario"
                                            component={EscolherTipo}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/selecionar_titular"
                                            component={SelecionarTitular}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/adicionar_titular"
                                            component={AdicionarTitular}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/adicionar_dependente"
                                            component={AdicionarDependente}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/upload_documentos"
                                            component={UploadDocuments}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/revisar_dados"
                                            component={RevisarDadosAdicionar}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/validar_inclusao_beneficiario"
                                            component={AguardarAnaliseAdicionar}
                                        />
                                        {/* Fim Adicionar beneficiário */}

                                        {/* Alterar beneficiário */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/selecionar_alterar_beneficiario"
                                            component={SelecionarAlterarBeneficiario}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/alterar_titular"
                                            component={AlterarTitular}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/alterar_dependente"
                                            component={AlterarDependente}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/validar_alteracao_beneficiario"
                                            component={AguardarAnaliseAlterar}
                                        />
                                        {/* Fim Alterar beneficiário */}

                                        {/* Desligar beneficiário */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/selecionar_desligar_beneficiario"
                                            component={SelecionarDesligarBeneficiario}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/desligar_beneficiario"
                                            component={DesligarBeneficiario}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/validar_desligamento_beneficiario"
                                            component={AguardarAnaliseDesligar}
                                        />
                                        {/* Fim Desligar beneficiário */}

                                        {/* Reativar beneficiário */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/selecionar_reativar_beneficiario"
                                            component={SelecionarReativarBeneficiario}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/reativar_beneficiario"
                                            component={ReativarBeneficiario}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/validar_reativar_beneficiario"
                                            component={AguardarAnaliseReativar}
                                        />
                                        {/* Fim Reativar beneficiário */}

                                        {/* Trocar Plano */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/selecionar_trocar_plano"
                                            component={SelecionarTrocarPlano}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/trocar_plano"
                                            component={TrocarPlano}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/validar_trocar_plano"
                                            component={AguardarTrocarPlano}
                                        />
                                        {/* Fim Trocar Plano */}

                                        {/* Aposentados e Demitidos */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/selecionar_aposentados_demitidos"
                                            component={SelecionarAposentadosDemitidos}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/preencher_dados_aposentados_demitidos"
                                            component={PreencherDadosAposentadosDemitidos}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/carregar_documentos_aposentados_demitidos"
                                            component={CarregarDocumentosAposentadosDemitidos}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/aguardar_analise_aposentados_demitidos"
                                            component={AguardarAnaliseAposentadosDemitidos}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/salvar_rascunho_aposentados_demitidos"
                                            component={SalvarRascunhoAposentadosDemitidos}
                                        />
                                        {/* Fim Aposentados e Demitidos */}

                                        {/* Transferir beneficiário */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/selecionar_transferencia_beneficiario"
                                            component={SelecionarTransferirBeneficiario}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/transferencia_beneficiario"
                                            component={TransferirBeneficiario}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/validar_transferencia_beneficiario"
                                            component={AguardarTransferirBeneficiario}
                                        />
                                        {/* Fim Transferir beneficiário */}

                                        {/* Movimentacoes Pendentes */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/movimentacoes_pendentes"
                                            component={MovimentacoesPendentes}
                                        />
                                        {/* Fim Movimentacoes Pendentes */}

                                        {/* Movimentacoes Por Arquivo */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/movimentacoes_arquivo"
                                            component={MovimentacoesPorArquivo}
                                        />
                                        {/* Fim Movimentacoes Por Arquivo */}

                                        {/* Histórico de movimentação */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/historico_movimentacao"
                                            component={HistoricoDeMovimentacao}
                                        />
                                        {/* Fim Histórico de movimentação */}

                                        {/* Centro de Custo */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/selecionar_centro_custo"
                                            component={SelecionarCentroDeCusto}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/formulario_centro_custo"
                                            component={FormCentroDeCusto}
                                        />
                                        {/* Fim Centro de Custo */}

                                        {/* Lotacoes */}
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/selecionar_lotacao"
                                            component={SelecionarLotacao}
                                        />
                                        <Route
                                            exact
                                            path="/movimentacao_cadastral/formulario_lotacao"
                                            component={FormLotacao}
                                        />
                                        {/* Fim Lotacoes */}

                                        {/* Demonstrativo Imposto de Renda */}
                                        <Route
                                            exact
                                            path="/dados_beneficiario/seleciona_beneficiario_imposto_renda"
                                            component={SelecionarBeneficiarioImpostoRenda}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/demonstrativo_imposto_renda"
                                            component={DemonstrativoImpostoRenda}
                                        />
                                        {/* Fim Demonstrativo Imposto de Renda */}

                                        {/* Demonstrativo Coparticipação */}
                                        <Route
                                            exact
                                            path="/dados_beneficiario/seleciona_beneficiario_coparticipacao"
                                            component={SelecionarBeneficiarioCoparticipacao}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/demonstrativo_coparticipacao"
                                            component={DemonstrativoCoparticipacao}
                                        />
                                        {/* Fim Demonstrativo Coparticipação */}

                                        {/* Tabela franquia */}
                                        <Route
                                            exact
                                            path="/dados_beneficiario/selecionar_beneficiario_franquia"
                                            component={SelecionarBeneficiarioFranquia}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/visualizar_tabela_franquia"
                                            component={TabelaFranquia}
                                        />
                                        {/* Fim Tabela franquia */}

                                        {/* Registro de Acidentados/Solicitacao Guias */}
                                        <Route exact path="/dados_beneficiario/guias" component={Guias} />

                                        <Route
                                            exact
                                            path="/dados_beneficiario/selecionar_beneficiario_guia"
                                            component={GuiaSelecionarBeneficiario}
                                        />

                                        <Route
                                            exact
                                            path="/dados_beneficiario/consultar_guias"
                                            component={ConsultarGuias}
                                        />

                                        <Route
                                            exact
                                            path="/dados_beneficiario/selecionar_solicitacao_guias"
                                            component={SelecionarSolicitacaoGuias}
                                        />

                                        <Route
                                            exact
                                            path="/dados_beneficiario/validar_solicitacao_guias"
                                            component={AguardarAnalise}
                                        />

                                        <Route
                                            exact
                                            path="/dados_beneficiario/carregar_documentos_solicitacao_guias"
                                            component={Documentos}
                                        />

                                        <Route
                                            exact
                                            path="/dados_beneficiario/preencher_dados_solicitacao_guias"
                                            component={PreencherDados}
                                        />
                                        {/* Fim Registro de Acidentados/Solicitacao Guias */}

                                        {/* Fim Registro de Acidentados/Acidente */}

                                        {/* Inicio Registro de Acidentados/PesquisaRede */}

                                        <Route
                                            exact
                                            path="/dados_beneficiario/pesquisa_rede"
                                            component={PesquisaRedeSelecionaBeneficiario}
                                        />

                                        <Route
                                            exact
                                            path="/dados_beneficiario/pesquisa_rede/seleciona_rede_assistencial"
                                            component={PesquisaRedeSelecionaRedeAssistencial}
                                        />

                                        <Route
                                            exact
                                            path="/dados_beneficiario/consulta_beneficiario_eventual"
                                            component={ConsultaBeneficiarioEventual}
                                        />

                                        <Route
                                            exact
                                            path="/registro_acidentados/consulta_beneficiario_eventual"
                                            component={ConsultaBeneficiarioEventual}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/consulta_beneficiario_eventual/agendamento_consulta"
                                            component={ConsultaBeneficiarioEventualAgendamento}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/consulta_beneficiario_eventual/cancelamento_consulta"
                                            component={ConsultaBeneficiarioEventualCancelamento}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/consulta_beneficiario_eventual/agendamento_consulta_dados"
                                            component={ConsultaBeneficiarioEventualAgendamentoDados}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/consulta_beneficiario_eventual/lista_consulta_dados"
                                            component={ConsultaBeneficiarioEventualListaConsultaDados}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/consulta_beneficiario_eventual/agendamento_consulta_dados_consulta"
                                            component={ConsultaBeneficiarioEventualAgendamentoDadosConsulta}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/consulta_beneficiario_eventual/agendamento_consulta_medico"
                                            component={ConsultaBeneficiarioEventualAgendamentoDadosMedicoConsulta}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/consulta_beneficiario_eventual/agendamento_consulta_confirmar_dados"
                                            component={ConsultaBeneficiarioEventualAgendamentoDadosConfirmar}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/historico_consultas"
                                            component={SelecionarHistoricoConsultas}
                                        />
                                        <Route
                                            exact
                                            path="/dados_beneficiario/historico_consultas_dados"
                                            component={DadosHistoricoConsultas}
                                        />
                                        {/* Fim Registro de Acidentados/PesquisaRede */}

                                        {/* Consultar Fatura */}
                                        <Route
                                            exact
                                            path="/faturamento/consultar_faturas"
                                            component={ConsultarFaturas}
                                        />
                                        {/* Fim Consultar Fatura */}

                                        {/* Materiais de apoio */}
                                        <Route exact path="/central_ajuda/materiais_apoio" component={MateriaisApoio} />
                                        {/* Fim Materiais de apoio */}

                                        <Route component={NotFound} />
                                    </Switch>
                                </BeneficiarioEventualProvider>
                            </SolicitacaoGuiasProvider>
                        </MovimentacoesPorArquivoProvider>
                    </AposentadosDemitidosProvider>
                </DependentesProvider>
            </TitularProvider>
        </>
    );
}

export default Routes;
